export const getTypeProps = (type) => {
    const types = {
        positive: {
            border: "--semantic-promo-base",
            background: "--semantic-success-weak-light",
            iconName: "check_circle",
            iconColor: "--semantic-success-base",
        },
        negative: {
            border: "--semantic-warning-base",
            background: "--semantic-error-weak",
            iconName: "cancel",
            iconColor: "--semantic-error-text",
        },
        info: {
            border: "--border-active",
            background: "--surface-accent-light",
            iconName: "info",
            iconColor: "--text-link",
            grade: 200,
            weight: 700,
        },
        warn: {
            border: "--semantic-warning-base",
            background: "--semantic-warning-weak",
            iconName: "error",
            iconColor: "--semantic-warning-text",
            weight: 700,
        },
    };
    return types[type];
};
//# sourceMappingURL=helpers.js.map